import React, { useState, useEffect } from 'react'
import ReportHeader from './components/ReportHeader'
import ReportResults from './components/ReportResults'
import messages from './messages'
import { useIntl } from 'react-intl'

const AccountingDraftOrdersPage = () => {
    const { formatMessage } = useIntl()
    const [entries, setEntries] = useState([])
    const [loading, setLoading] = useState(false)
    const [selectedOrderIds, setSelectedOrderIds] = useState([])
    useEffect(() => {
        handleSearch()
    }, [])

    const handleSearch = (params = {}) => {
        setLoading(true)
        const filteredParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== null && value !== '')
        )

        const urlSearchParams = new URLSearchParams(filteredParams)
        const queryString = urlSearchParams.toString()

        fetch(`/rest/v2/accounting/accounting-draft-orders${queryString ? `?${queryString}` : ''}`)
        .then((response) => response.json())
        .then(({ data, success, errors }) => {
            if (!success) {
                toastr.error(errors.join(', '))
                return
            }
            setEntries(data)
            setLoading(false)
        })
        .catch((error) => toastr.error(error))
    }

    const handleOnOrderSelected = (id) => {
        if (selectedOrderIds.includes(id)) {
            setSelectedOrderIds((prev) => prev.filter((taskId) => taskId !== id))
        } else {
            setSelectedOrderIds((prev) => [...prev, id])
        }
    }

    const handleOrderSend = (orderIds) => {
        if (confirm(formatMessage(messages.confirmSendOrderPrompt))) {
            setLoading(true)
            fetch(`/rest/v2/accounting/accounting-draft-orders`, {
                method: 'PUT',
                body: JSON.stringify({
                    orderIds: orderIds
                })
            })
            .then((response) => response.json())
            .then(({success, errors, data}) => {
                if (!success) {
                    toastr.error(errors.join(', '))
                } else {
                    if (data?.sentOrderIds) {
                        toastr.success(formatMessage(messages.sendSuccess, { orderIds: data?.sentOrderIds.join(', ') }))
                    }
                    if (data?.errorOrderIds) {
                        toastr.error(formatMessage(messages.sendError, { orderIds: data?.errorOrderIds }))
                    }
                    handleSearch()
                }
            })
            .catch((error) => {
                toastr.error(error)
                setLoading(false)
            })
        }
    }

    return (
        <div className="w-full h-full">
            <ReportHeader
                loading={loading}
                onSearch={handleSearch}
            />
            <ReportResults
                selectedOrderIds={selectedOrderIds}
                onOrderSelected={handleOnOrderSelected}
                loading={loading}
                entries={entries}
                onOrdersSend={handleOrderSend}
            />
        </div>
    )
}

export default AccountingDraftOrdersPage
